<template>
  <Navbar></Navbar>
  <router-view />
  <Footer></Footer>
</template>

<script>
import Navbar from '@/sections/Navbar.vue';
import Footer from '@/sections/Footer.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  },
}
</script>

<style>
#app {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 1.55;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  background-color: #eeeeee;
}

.no-scroll::-webkit-scrollbar {
  display: none !important;
}
</style>
